import styled from 'styled-components';

export const UsersReviewsStyles = styled.section`
  body.dark & {
    --review-bg: #803eff12;
  }

  --review-bg: #f0f0f0;

  display: flex;
  flex-direction: column;
  gap: 12px;

  .paywall-users-reviews-review {
    padding: 16px;
    border-radius: 8px;
    background: var(--review-bg);
    display: flex;
    flex-direction: column;

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 12px;
    }

    &-user-info {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &-country {
      font-size: 16px;
      line-height: 1;
    }

    &-author {
      margin: 0 0 8px;
    }

    &-date {
      margin: 0;
    }

    &-stars {
      margin: 0 0 8px;
    }

    &-text {
      margin-bottom: 8px;
    }

    &-source {
      margin-top: auto;
      opacity: 0.6;
    }
  }
`;
